'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const React = require('react');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_navigation_InteractiveTag_InteractiveTagContext = require('./InteractiveTagContext.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = {
  root: react.css(Object.assign(Object.assign({}, styleMixins_reset.boxSizing), { overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }))
};
const InteractiveTagContent = ({ body, title }) => {
  const contentRef = React.useRef(null);
  const { setBody, setIsTruncated, setTitle } = components_navigation_InteractiveTag_InteractiveTagContext.useInteractiveTagContext();
  const checkIsTruncated = () => {
    if (contentRef.current) {
      return contentRef.current.scrollWidth > contentRef.current.clientWidth;
    }
    return false;
  };
  React.useEffect(() => {
    setIsTruncated(checkIsTruncated());
    setBody(body);
    setTitle(title);
  }, []);
  return react.jsx(
    "div",
    { css: Styles.root, ref: contentRef, "data-zds": true },
    react.jsx(
      components_display_Text_Text.Text,
      { color: "inherit", type: "Body3" },
      title,
      body ? ": " : ""
    ),
    body && react.jsx(components_display_Text_Text.Text, { color: "inherit", type: "Body1" }, body)
  );
};

exports.InteractiveTagContent = InteractiveTagContent;
//# sourceMappingURL=InteractiveTagContent.cjs.js.map
